import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 70,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
    [theme.breakpoints.down('sm')]: {
      paddingBlock: 0,
      paddingBlockStart: 24,
      paddingBlockEnd: 50,
    },
  },
  title: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      color: theme.palette.custom.main,
      paddingBlockEnd: 28,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: 28,
      },
    },
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 16,
    // paddingBlockStart: 20,
  },
  cardWrapper: {
    width: '99%',
    paddingInline: 8,
    minHeight: 270,
    [theme.breakpoints.down('sm')]: {
      minHeight: 244,
    },
    transition: 'all 0.3s ease-in-out 0s',
    '&:hover': {
      '& $img': {
        transform: 'scale(1.02)',
        transition: 'all 0.3s ease-in-out 0s',
      },
    },
  },
  card: {
    width: '100%',
    height: '100%',
    border: '1px solid #d7d7d7',
    borderRadius: 6,
    cursor: 'pointer',
    overflow: 'hidden',
  },
  img: {
    width: '100%',
    height: 180,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      height: 160,
    },
  },
  content: {
    paddingBlockStart: 12,
  },
  name: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      color: theme.palette.custom.main,
      fontWeight: 600,
      textTransform: 'capitalize',
    },
  },
  price: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      paddingBlockStart: 8,
      fontSize: 20,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
      },
    },
  },
}))

export default useStyles
